/** Actions on an approval-path step (mirrors DecisionStepActionEnum on the API). */
export enum DecisionStepAction {
	Submitted = 1,
	Approved = 2,
	Returned = 3,
	NoteAdded = 4,
}
